import '../styles/process.css';
import { useInView } from 'react-intersection-observer';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

/* ── Slide definitions ──────────────────────────────────────────
   src: path relative to /public
   titleKey / subKey: i18n keys from data.js
   ─────────────────────────────────────────────────────────────── */
const SLIDES = [
  { src: '/images/fun (1).webp',                          titleKey: 'slide_1_title',  subKey: 'slide_1_sub'  },
  { src: '/images/fun (2).webp',                          titleKey: 'slide_2_title',  subKey: 'slide_2_sub'  },
  { src: '/images/fun (3).webp',                          titleKey: 'slide_3_title',  subKey: 'slide_3_sub'  },
  { src: '/images/fun (4).webp',                          titleKey: 'slide_4_title',  subKey: 'slide_4_sub'  },
  { src: '/images/fun (5).webp',                          titleKey: 'slide_5_title',  subKey: 'slide_5_sub'  },
  { src: '/images/fun (6).webp',                          titleKey: 'slide_6_title',  subKey: 'slide_6_sub'  },
  { src: '/images/fun (7).webp',                          titleKey: 'slide_7_title',  subKey: 'slide_7_sub'  },
  { src: '/images/fun (8).webp',                          titleKey: 'slide_8_title',  subKey: 'slide_8_sub'  },
  { src: '/images/fun (9).webp',                          titleKey: 'slide_9_title',  subKey: 'slide_9_sub'  },
  { src: '/images/fun (10).webp',                         titleKey: 'slide_10_title', subKey: 'slide_10_sub' },
  { src: '/images/pantallazo_price_index.PNG',            titleKey: 'slide_11_title', subKey: 'slide_11_sub' },
  { src: '/images/pantallazo_share_of_innovation.PNG',    titleKey: 'slide_12_title', subKey: 'slide_12_sub' },
  { src: '/images/pantallazo_competitividad_cadenas.PNG', titleKey: 'slide_13_title', subKey: 'slide_13_sub' },
  { src: '/images/pantallazo_agotados.PNG',               titleKey: 'slide_14_title', subKey: 'slide_14_sub' },
];

const slideProperties = {
  duration: 4500,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: true,
  pauseOnHover: true,
};

function Process({ t }) {
  const [ref, inView] = useInView({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className={`process-section ${inView ? 'process-visible' : ''}`}
      id="Funcionalidades"
      aria-label="Funcionalidades Shelf-e"
    >
      <div className="process-inner">
        {/* Section heading */}
        <div className="process-header">
          <h2 className="process-title">{t('seccion4_1')}</h2>
          <p className="process-subtitle">
            {t('slide_2_title')} · {t('slide_8_title')} · {t('slide_13_title')}
          </p>
        </div>

        {/* Carousel */}
        <div className="process-carousel">
          <Slide {...slideProperties}
            indicators={(index) => (
              <div className="slide-dot" aria-label={`Slide ${index + 1}`} />
            )}
          >
            {SLIDES.map((slide, i) => (
              <div key={i} className="slide-wrap">
                {/* Screenshot */}
                <div className="slide-img-wrap">
                  <img
                    src={slide.src}
                    alt={t(slide.titleKey)}
                    className="slide-img"
                    loading="lazy"
                  />
                </div>

                {/* Caption overlay at bottom */}
                <div className="slide-caption">
                  <div className="slide-caption-inner">
                    <span className="slide-num">{String(i + 1).padStart(2, '0')} / {String(SLIDES.length).padStart(2, '0')}</span>
                    <h3 className="slide-title">{t(slide.titleKey)}</h3>
                    <p className="slide-sub">{t(slide.subKey)}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slide>
        </div>
      </div>
    </section>
  );
}

export default Process;
